import { formatNumber } from "@features/utils";
import { ArrowLeftIcon } from "@heroicons/react/16/solid";
import { Badge, Box, Flex, Heading, Table, Text } from "@radix-ui/themes";
import { getPreviousPath, Page } from "@views/layout/layout";
import { formatDate } from "date-fns";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// TODO: Replace with actual presets hook when available
const usePresets = () => {
  return {
    presets: {
      data: [] as Array<{
        id: string;
        name: string;
        description?: string;
        public: boolean;
        uses_count?: number;
        created_at?: string;
      }>,
      isLoading: false,
    },
  };
};

export const MyPresets = () => {
  const { t } = useTranslation();
  const { presets } = usePresets();

  return (
    <Page>
      <div className="max-w-4xl mx-auto p-4 md:p-8">
        {/* Header */}
        <Flex align="center" gap="4" className="mb-6">
          <Link to={getPreviousPath()}>
            <ArrowLeftIcon className="h-5 w-5 text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 cursor-pointer" />
          </Link>
          <Heading size="6">{t("my_presets.title")}</Heading>
        </Flex>

        {/* Description */}
        <Text size="2" color="gray" className="mb-6 block">
          {t("my_presets.description")}
        </Text>

        {/* Presets Table */}
        <Box className="border rounded-lg overflow-hidden dark:border-slate-700">
          <Table.Root>
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeaderCell>
                  {t("my_presets.table.name")}
                </Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>
                  {t("my_presets.table.description")}
                </Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>
                  {t("my_presets.table.public")}
                </Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>
                  {t("my_presets.table.uses")}
                </Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>
                  {t("my_presets.table.created")}
                </Table.ColumnHeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {presets.data?.map((preset) => (
                <Table.Row key={preset.id}>
                  <Table.Cell>
                    <Text weight="medium">{preset.name}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text size="2" color="gray">
                      {preset.description || "-"}
                    </Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Badge
                      variant="soft"
                      color={preset.public ? "blue" : "gray"}
                    >
                      {preset.public
                        ? t("my_presets.public")
                        : t("my_presets.private")}
                    </Badge>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(preset.uses_count || 0)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text size="1" color="gray">
                      {preset.created_at
                        ? formatDate(new Date(preset.created_at), "MMM d, yyyy")
                        : "-"}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              ))}

              {(!presets.data || presets.data.length === 0) && (
                <Table.Row>
                  <Table.Cell colSpan={5}>
                    <Text
                      color="gray"
                      size="2"
                      className="text-center py-8 block"
                    >
                      {t("my_presets.empty")}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table.Root>
        </Box>
      </div>
    </Page>
  );
};
